export default __webpack_public_path__ + "static/media/AG.2ebbc8c2.svg";